import { render, staticRenderFns } from "./AssignTemplatesToEmployee.vue?vue&type=template&id=12eab474&scoped=true"
import script from "./AssignTemplatesToEmployee.vue?vue&type=script&lang=js"
export * from "./AssignTemplatesToEmployee.vue?vue&type=script&lang=js"
import style0 from "./AssignTemplatesToEmployee.vue?vue&type=style&index=0&id=12eab474&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eab474",
  null
  
)

export default component.exports